import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertComponent } from '../../../../shared/modals/alert/alert.component';
import { SuccessComponent } from '../../../../shared/modals/success/success.component';
import { EditOrganizationComponent } from './components/edit-organization/edit-organization.component';
import { OrganizationService } from './organization.service';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss']
})
export class OrganizationComponent implements OnInit {

  displayedColumns: string[] = ['id','name','description','active', 'edit','delete'];
  dataSource = new MatTableDataSource<any>([]);
  isLoading = true;

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  constructor(public dialog: MatDialog,
              private organizationService: OrganizationService,
              private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.show();
    this.getOrganization();
  }

  async getOrganization(){
    console.log('In organization')
   await this.organizationService.getOrganization().subscribe(data => {
    if(data.length > 0){
      this.dataSource = new MatTableDataSource<any>(data);
      console.log(this.dataSource);
      this.dataSource.paginator = this.paginator;
      this.isLoading = false;
    } this.spinner.hide();
    });

  }

  editOrganization(data:any=null) {
    const dialogRef = this.dialog.open(EditOrganizationComponent,{
      data:data,
      maxWidth: '80%',
		  minWidth: 'fit-content'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  // viewOrganization(data:any){
  //   const dialogRef = this.dialog.open(ViewOrganizationComponent,{
  //     data:data,
  //     width: '100vw'
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(`Dialog result: ${result}`);
  //   });
  // }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  deleteOrganization(data:any=null){
    console.log(data)
    const dialogRef = this.dialog.open(AlertComponent,{
      data:{
        title:"Are you sure!",
        subTitle:"Do you want to delete this Organization"
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if(result){
        this.spinner.show();
        this.organizationService.deleteOrganization(data.id);
        this.spinner.hide();
        this.dialog.open(SuccessComponent,{data:{title:"Deleted!",subTitle:"Organization deleted successfully."}});
      }
    });
  }


}
